export default {
    tabbar: {
        home: 'الصفحة الرئيسية',
        trading: 'صفقة',
        invest: 'استثمر',
        share: 'شارك',
        mine: 'أنا التي'
    },
    common: {
        deposit: 'وديعة',
        withdrawal: 'سحب',
        share: 'شارك',
        team: 'فريق',
        task: 'مهمة',
        addr: 'عنوان',
        logout: 'شطب',
        wallet: 'محفظة',
        account: 'الحسابات',
        promotion: 'الترويج',
        details: 'تفاصيل',
        dailyRevenue: 'الدخل اليومي',
        dailyRevenueList: 'قائمة الدخل اليومي',
        aboutUs: 'عنا',
        globalPartners: 'الشركاء العالميين',
        totalBalance: 'مجموع الرصيد',
        profitList: 'قائمة الدخل المالي',
        notification: 'إخطار',
        previous: 'المادة السابقة',
        close: 'غلق',
        next: 'المادة التالية',
        investWallet: 'محفظة استثمارية',
        financialWallet: 'المحفظة المالية',
        recharge: 'شحن',
        copySucceeded: 'نسخة ناجحة',
        copyFailed: 'فشل النسخ',
        promotionWallet: 'تعزيز محفظة',
        registerRewardWallet: 'سجل مكافأة المحفظة',
        toAddress: 'تي آر إكس المحفظة العنوان ( بداية )',
        verifyYourPassword: 'التحقق من كلمة السر الخاصة بك',
        serviceFee: 'Gas fees',
        confirm: 'أكّد',
        submitted: 'قدم',
        date: 'تواريخ',
        amount: 'مبلغ',
        accountAvailableBalance: 'رصيد الحساب المتاح',
        securityPassword: 'كلمة سر آمنة',
        withdrawalPrincipal: 'استخراج الرئيسية',
        withdrawalProfit: 'سحب الأرباح',
        profitRate: 'سعر الفائدة',
        notificationAndFAQ: 'الأسئلة الشائعة والإشعارات',
        FAQ: 'التعليمات',
        FAQs: [
            {
                id: 'q1',
                title: 'Q:مميزات المشروع/المقدمة',
                content: `R:
1. باعتبارنا رمز الاستثمار المدقق الأول والمثبت في الصناعة، يهدف حلنا إلى إثبات أن العقود الذكية هي مستقبل الاستثمار. سيؤدي طول عمرها واستقرارها في النهاية إلى تعطيل صناعة العملات المشفرة والطريقة التي يفكر بها الناس في الاستثمار والتداول. تواجه صناعة الرموز التقليدية العديد من التحديات، بما في ذلك عمليات الاحتيال الرمزية والسجاد وتقلبات السوق والمطورين غير الشرفاء الذين يسرقون أموال المستخدمين ونقص السيولة.

2. يعتمد رمز الموثوقية الذي لدينا على هيكل الحل ولن يتأثر حلنا بأي شكل من الأشكال بهذه التحديات والعديد من التحديات الأخرى التي تنشأ في صناعة العملات المشفرة. منصتنا لا تتطلب سيولة في السوق. لذلك، فإن استثمارك ودخلك المتوقع آمنان لأننا لا نعتمد على التغيرات في الصناعة. بدلاً من ذلك، قمنا ببناء حل يعتمد على جاذبية المستخدم الجديد ولكن يعمل على العقود الذكية! إن الكود والهيكل الخاص بنا آمنان، مع ضمان طول العمر والشفافية. ولذلك، لدينا برنامج إحالة جذاب وقوي للغاية مع إحصائيات مفصلة وشفافة لكل مروج/مستخدم. تتم إضافة أرباح المنشئ، بالإضافة إلى أرباح المستخدمين الآخرين، على الفور إلى الملف الشخصي، وعلى عكس حلول استثمار DeFi الأخرى، يمكن للأشخاص سحب الأموال على الفور في أي وقت.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q2',
                title: 'Q:ما هي ميزتنا ؟',
                content: `R:يتم تدقيق أنظمتنا من قبل فريق أمان Haze ولديهم مدققون مستقلون للعقود الذكية
1. آمن وموثوق: لا حاجة لتحويل العملة، حيث يتم إيداع USDT في محفظتك الخاصة دون أي مخاطر
2. الاستقرار المهني: فريق محترف، عملية مستقرة على مدار العام
3. عتبة دخول منخفضة: دخل تعدين العقدة
4.USD ETHW AI Strategy-C Mining Pool: لا حاجة لتحويل العملة، دخل ثابت
5. نحن ملتزمون ببناء أكبر منصة DeFi متكاملة في العالم DEX وIMO وDAO`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q3',
                title: 'Q:كيف أشارك؟',
                content: `R:
1. المحفظة موجودة على السلسلة، ومحطة المحفظة مجهزة بمتصفح Dapp.
2. قم بتوصيل TRC20 بـ USDT وقم بإيداعه في محفظتك
3. أدخل إلى Gongwang من خلال متصفح المحفظة
4. يجب أن تحتوي محفظتك على أكثر من 30 تريليون دولار كرسوم تعدين للمشاركة في هذا المشروع
`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q4',
                title: 'Q:كم من الوقت يستغرق المشاركة في التعدين؟',
                content: `R:لا يمكن حساب الوقت. عادة يمكن الانتهاء منه في غضون 4 ساعات. إذا تمت مواجهة أسباب أخرى غير مؤكدة، فقد يتم تمديد الوقت.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q5',
                title: 'Q:لماذا نحتاج إلى دفع رسوم التعدين لصرف الأرباح؟',
                content: `R:لأنه في عملية المشاركة في التعدين هذه، يتم احتساب العملاء بالاسم فقط، ويتم دفع رسوم التعدين الناتجة من قبل عمال المناجم. الدخل الناتج موجود فعليًا في مجمع العقود، وفقط من خلال دفع رسوم التعدين يمكنك تبادل الدخل.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q6',
                title: 'Q:كيفية سحب الأرباح؟',
                content: `R:بعد الحصول على USDT، يجب أن يكون لديك مبلغ صغير من TRX في محفظتك لتغطية رسوم المعاملات. ما عليك سوى الدفع مرة واحدة، وسيتم إكمال عملية تبادل USDT خلال يوم عمل قانوني واحد. عندما تبدأ عملية سحب، سيتم إرسال سحب USDT تلقائيًا إلى عنوان المحفظة الخاص بالعقدة التي انضممت إليها. العناوين الأخرى غير مدعومة.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q7',
                title: 'Q:ما هو تعدين السيولة Defi؟',
                content: `R:تعدين السيولة هو نوع من التمويل اللامركزي DeFi. فهي لا تحتاج إلى شراء بطاقات رسومية، أو المساهمة في الطاقة الحاسوبية، أو دفع فواتير كهرباء باهظة الثمن، ولكنها تكسب الدخل من خلال توفير الأموال والسيولة. تقلبت أسعار العملات بشكل كبير في الآونة الأخيرة. بالنسبة لبعض حاملي العملات الملتزمين، يعد تعدين السيولة وسيلة لكسب الدخل وتجميع المزيد من العملات المشفرة دون الحاجة إلى المعاملات.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q8',
                title: 'Q:كيف يعمل؟',
                content: `R:الحل الذي نقدمه هو اتفاقية معاملة محوسبة تعمل تلقائيًا على فرض شروط العقد بين الطرفين. كما هو الحال مع العقود العالمية، يجب على كلا المستخدمين على منصتنا تحديد قواعد وشروط المشاركة عند التداول. بمجرد التوصل إلى اتفاق وإطلاق عقد ذكي، فإنه يعمل كما هو مصمم، مع عدم وجود فرصة لتغيير الشروط المحددة مسبقًا. عندما يبدأ المستخدم نشاطًا في مجمع التعدين الخاص بعقدة blockchain، يجب أن يكون هناك رصيد متاح في العقد. ويترك باقي المستخدمين الأمر للعقد ليتم تنفيذه، ولم يعد عليهم الانتظار لساعات طويلة للتحقق من وقت البيع أو الشراء. لذلك، وفقًا لشروط العقد، نضمن عدم انخفاض قيمة استثمارك أبدًا؛ على العكس من ذلك، فهو يحقق ربحًا بنسبة 100% لمستخدمينا.`,
                updatedAt: '2019-07-23 12:00:00'
            }
        ],
        minWithdrawalError: 'يجب أن يكون مبلغ السحب أكبر من رسوم الغاز المستهلكة',
        supportTips: 'عزيزي المستخدم: لقد أنشأنا لك خدمة مساعد تجمع التعدين الحصرية. يمكنك الكتابة إلينا للتشاور والشكاوى والاقتراحات وما إلى ذلك، وسوف نقوم بالرد والتعامل معها في غضون 24 ساعة!',
        tips: 'نصائح',
        Withdrawals_prohibited: 'شروط السحب غير مستوفاة حاليا، يرجى إكمال المهمة أولا.'
    },
    homePage: {
        theCommonProblem: 'أسئلة وأجوبة',
        latestAnnouncement: 'أحدث الإعلانات',
        block5title: 'الانضمام إلى ترون المليونير',
        block5desc: 'استخدام سحابة التعدين وديفي التكنولوجيا لضمان أن جميع المستخدمين الحصول على أقصى قدر من الدخل USDT。',
        block6title: 'منصة عرض البيانات',
        accumulatedProfit: 'الدخل التراكمي',
        membership: 'عضو',
        block7title: 'نحن في أفضل حالاتنا',
        block7desc: 'hako هي شركة مسجلة في سنغافورة، رقم الترخيص: PS20200556. نحن الموقع الإلكتروني الاستثماري للعقود الذكية الوحيد الذي تم تدقيقه والتحقق منه في مجال العملات المشفرة والذي يعمل على شبكة TRON Smart Chain (TRON). يوفر التعدين السحابي hako خط أنابيب تعدين فعال من حيث التكلفة لعملة Bitcoin USDT والعملات المشفرة الأخرى. في الوقت نفسه، سيسمح لك كل من التداول الكمي وتقنية DeFi بالمشاركة بسهولة في معاملات blockchain بكمية صغيرة من رأس المال والحصول على دخل ثابت مثل التأمين.',
        tzl: 'الاستثمار',
        zl: 'كسب'
    },
    investPage: {
        productList: 'قائمة المنتجات',
        investedList: 'قائمة الاستثمارات',
        dailyRate: 'سعر الفائدة اليومي',
        cycle: 'دورة',
        day: 'أيام .',
        productDetails: 'تفاصيل المنتج'
    },
    tradingPage: {
        miningWorking: 'سحابة التعدين هو العمل',
        tradingProfit: 'عائدات المعاملات',
        settlementRule: 'تسوية 24 ساعة',
        viewAll: 'عرض جميع',
        quantifyingTransactionRevenue: 'دخل التداول النوعي',
        receive: 'جمع',
        received: 'تلقى',
        rule: 'قواعد التعدين',
        rules: 'إذا كنت تريد أن يبدأ "التعدين السحابي" العمل ويحقق لك دخل يومي، يرجى تفعيله في "المحفظة المالية". عندما يستوفي رصيد USDT في محفظتك شروطًا معينة، ستتلقى دخلاً يوميًا، وسيتم الاحتفاظ بالدخل الناتج لمدة 30 يومًا. الرجاء النقر للمطالبة بها في الوقت المناسب. احسب نسبة إيراداتك اليومية بناءً على الجدول أدناه:',
        profit: 'ربح',
        miningNotWorking: 'التعدين السحابي لا يعمل، يرجى تفعيله',
        balance: 'توازن'
    },
    sharePage: {
        text1: 'دعوة جهات الاتصال الخاصة بك',
        text2: 'أو الأصدقاء والحصول على مكافآت',
        text3: 'التوصية والمكافآت',
        text4: 'حصة الخاص بك وصلات الموصى بها والبدء في كسب المال',
        copyLink: 'نسخ اتصال'
    },
    minePage: {
        trxDepositInvestment: 'USDT ودائع الاستثمار',
        trxDepositFinancial: 'USDT الودائع المالية',
        tips: 'إيداع أي عدد من USDT لتفعيل الحساب وفتح وظيفة السحب',
        appServices: 'خدمات التطبيقات'
    },
    depositPage: {
        text1: 'الاستثمار ينقسم إلى نموذجين',
        text2: '1:إعادة شحن في المحفظة الخاصة بك ، يمكنك الحصول على العودة في دورات مختلفة ، والعودة الرئيسية والعائدات عند الاستحقاق .',
        text3: '2: قم بتفعيل وظيفة "التعدين السحابي" في محفظتك المالية، واحصل على الدخل حسب توقيت سنغافورة (بعد الساعة 12 ظهرًا) كل يوم',
        text4: 'الحواشي:',
        text5: 'قبل الاستثمار ، يرجى اختيار حساب الاستثمار أو الحساب المالي للاستثمار الخاص بك وفقا للاحتياجات . تأكد من انتظار شحن الحساب . هذا هو السؤال الحاسم . 。'
    },
    rechargePage: {
        trxAddress: 'عنوان TRC20-USDT',
        copyAddress: 'نسخ العنوان',
        tips1: 'من فضلك لا تهمة أخرى غير USDT الأصول . بعد شحن حوالي 5-10 دقائق لتسجيل。',
        tips2: 'إذا لم يتم تسليمها لفترة طويلة ، يرجى تحديث هذه الصفحة . الحد الأدنى للاستثمار 5USDT。',
        rechargeCompleted: 'الانتهاء من شحن',
        inactivated: 'معطل',
        activated: 'مفعل',
        tips3: 'لا حاجة للنقر مرارا وتكرارا. يبدأ التعدين السحابي في العمل بعد حوالي 5 إلى 10 دقائق من إرسال الطلب.',
        tips4: 'إذا لم يتم تفعيله لفترة طويلة، يرجى النقر على زر التنشيط مرة أخرى.',
        ActivateCloudMining: 'تفعيل التعدين السحابي'
    },
    withdrawalPage: {
        text1: 'رصيد الحساب الأساسي ( USDT )',
        text2: 'سيتم استلام السحب في غضون 24 ساعة',
        dailyWithdrawalLimit: 'الحد اليومي',
        unlimit: 'غير محدود'
    },
    teamPage: {
        intro: 'يمكن للمستخدمين الذين تدعوهم بشكل مباشر وغير مباشر أن يكسبوا أرباحًا لك. لنفترض أنك قمت بدعوة المستخدم أ، فسيتم إرسال الدخل المالي الذي اكتسبه المستخدم أ إلى محفظتك كمكافأة مئوية. إذا قام المستخدم "أ" بدعوة المستخدم "ب"، وقام "ب" بدوره بدعوة "ج"، فيمكنك الحصول على النسبة المئوية لمكافأة دخل المستخدم من A ({lev2rate}%)، وB ({lev3rate}%)، وC ({lev4rate}%)!',
        level: 'التسلسل الهرمي',
        lev2: 'lv.2',
        lev3: 'lv.3',
        lev4: 'lv.4',
        quantity: 'الكمية',
        rewards: 'مكافأة'
    },
    productDetailsPage: {
        startingAmount: 'المبلغ الأولي',
        maxInvestmentAmount: 'أقصى قدر من الاستثمار',
        dailyInterestRate: 'سعر الفائدة اليومي',
        investableQuantity: 'كمية الاستثمار',
        investmentAmount: 'مبلغ الاستثمار',
        participateInInvestment: 'المشاركة في الاستثمار'
    },
    investedListPage: {
        investmentTime: 'وقت الاستثمار',
        settlementTime: 'وقت التسوية',
        settlementAmount: 'مبلغ التسوية'
    },
    loginPage: {
        MobileNumber: 'رقم الجوال',
        LoginPassword: 'كلمة السر',
        SignIn: 'سجل',
        SignUp: 'التسجيل',
        rememberThePassword: ' تذكر كلمة السر',
        inviteCode: 'رمز الدعوة',
        captcha: 'رمز التحقق',
        EncryptedRegistration: 'تشفير التسجيل',
        desc: 'يتم تخزين كلمة السر في خط أنابيب متناثرة و لا يمكن استرجاعها بعد أن فقدت . يرجى تذكر كلمة السر الخاصة بك。 ',
        registerSuccess: 'تم إنشاء حساب بنجاح'
    },
    taskPage: {
        desc: 'كل مبلغ من المال كنت قد دعوت للتسجيل في عضوية المرؤوس سيتم تحويلها إلى مبلغ السحب الخاص بك في نسبة معينة .',
        rwconvertRate: 'نسبة التحويل',
        totalLimit: 'المبلغ التراكمي',
        availableLimit: 'المبلغ المتاح',
        contactService: 'الاتصال بخدمة العملاء'
    },
    Please_unlock_your_wallet: 'يرجى فتح محفظتك',
    Please_open_the_website_in_the_Dapp_browser: 'يرجى فتح الموقع في متصفح Dapp'
}
